export type BillingsOrderRailyTaxiRecalculateParamsBillingNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventUuid?: string;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderRailyTaxiRecalculateParamsPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiRecalculateParamsBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

type BillingsOrderRailyTaxiRecalculateParams = {
  orderUuid: string;
  billingNodes: BillingsOrderRailyTaxiRecalculateParamsBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiRecalculateParamsPenaltyType;
  bonusType?: BillingsOrderRailyTaxiRecalculateParamsBonusType;
};

export default BillingsOrderRailyTaxiRecalculateParams;
